let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("jo8eM")]).then(() => parcelRequire('k2J4N'));